module.exports = __webpack_public_path__ + "static/media/01.Stage Outer View.5bd852e3.JPG";